import React from 'react';
import { arrayOf, string, func } from 'prop-types';
import { noop } from 'lodash';

import TagsDropdown from '../../shared/TagsDropdown';
import useMarketplaceTagsDropdownHandlers from './hooks/useMarketplaceTagsDropdownHandlers';

const MarketplaceTagsDropdown = ({ tags, setBriefData = noop }) => {
    const handlers = useMarketplaceTagsDropdownHandlers({ setBriefData });

    return <TagsDropdown {...handlers} tags={tags} />;
};

MarketplaceTagsDropdown.propTypes = {
    tags: arrayOf(string),
    setBriefData: func,
};

export default MarketplaceTagsDropdown;
